export default __webpack_public_path__ + "static/media/nativeMems.6131df52.png";